import React, { useRef } from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import { Stars } from '@react-three/drei';

// Slowly drifting starfield
function DriftingStars() {
    const group = useRef();
    useFrame((_, delta) => {
        if (group.current) {
            group.current.rotation.y += delta * 0.03;
            group.current.rotation.x += delta * 0.015;
        }
    });
    return (
        <group ref={group}>
            <Stars radius={90} depth={50} count={5000} factor={4} saturation={0} fade speed={1} />
        </group>
    );
}

// Transparent 3D canvas — sits ABOVE the shell's solid dark base, BELOW the card
export default function AuthBackground() {
    return (
        <div className="absolute inset-0 z-0">
            <Canvas camera={{ position: [0, 0, 1] }} dpr={[1, 1.5]}>
                <ambientLight intensity={0.5} />
                <DriftingStars />
            </Canvas>
        </div>
    );
}
